import React, { useState, useEffect } from "react"
import Carousel from "react-bootstrap/Carousel"
import { Row, Col } from "reactstrap"
import LazyLoad from "react-lazyload"

import Blog from "../../../Blogs/eachBlog"

import PostImg1 from "../../../../images/blogs/jitsimeet and firewall.png"
import PostImg2 from "../../../../images/blogs/how to install jitsi meet.png"
import PostImg3 from "../../../../images/blogs/setting up a turn server.png"

const BlogsCarousel = props => {
  const [index, setIndex] = useState(0)
  const [direction, setDirection] = useState(null)
  const [screenWidth, setScreenWidth] = useState(null)

  useEffect(() => {
    setScreenWidth(window.innerWidth)
  })

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex)
    setDirection(e.direction)
  }
  return (
    <div className="blogs">
      <LazyLoad offset={500}>
        <Carousel
          activeIndex={index}
          direction={direction}
          onSelect={handleSelect}
          interval={screenWidth < 576 ? null : 5000}
          indicators={screenWidth < 576 ? false : true}
        >
          <Carousel.Item>
            <Row>
              <Col md="4">
                <Blog
                  title="Jitsi Meet and Firewalls"
                  image={PostImg1}
                  readMore="https://meetrix.io/blog/webrtc/jitsi/jitsi-meet-and-firewalls.html"
                />
              </Col>
              <Col md="4">
                <Blog
                  title="How to Install Jitsi Meet"
                  image={PostImg2}
                  readMore="https://meetrix.io/blog/webrtc/jitsi/meet/installing.html"
                />
              </Col>
              <Col md="4">
                <Blog
                  title="Settingup a Turn Server for Jitsi Meet"
                  image={PostImg3}
                  readMore="https://meetrix.io/blog/webrtc/jitsi/setting-up-a-turn-server-for-jitsi-meet.html"
                />
              </Col>
            </Row>
          </Carousel.Item>
        </Carousel>
      </LazyLoad>
    </div>
  )
}

export default BlogsCarousel
